<template>
  <div v-wechat-title="$route.meta.title" class="product_wrap">
    <common-header @setLocale="getLocale"></common-header>
    <common-nav :locale="locale"></common-nav>
    <common-banner :locale="locale" title="product"></common-banner>
    <u-animate-container class="product_area">
      <!-- <img src="@/assets/images/bg_index_knowmore.jpg" class="product_area_bg"> -->
      <!-- <common-title
        :cn="$i18n.locale === 'zh-cn' ? '产品中心' : 'PRODUCT'"
      ></common-title> -->
      <div class="mobile_product_nav">
        <div
          class="mobile_product_nav_item"
          :class="isAcitveIndex == index ? 'active' : ''"
          @click="switchCategory($event, index)"
          v-for="(item, index) in categoryList"
          :key="item['name'] + item.productId"
          :data-id="item['pcId']"
        >
          {{ item["name"] }}
        </div>
      </div>
      <u-animate
        class="product_cate"
        name="fadeInDown"
        delay="0s"
        duration="1s"
        :iteration="1"
        :offset="0"
        animateClass="animated"
        :begin="false"
      >
        <!-- <router-link :to="'/product/'+ item['pcId']" class="menu_item" tag="div" :class="categoryId===item['pcId']?'active':''" v-for="item in categoryList" :key="item['name']" :data-id="item['pcId']">{{item['name']}}</router-link> -->
        <div
          class="menu_item"
          @click.capture="switchCategory($event, index)"
          :class="isAcitveIndex == index ? 'active' : ''"
          v-for="(item, index) in categoryList"
          :key="item['name'] + item.productId"
          :data-id="item['pcId']"
        >
          <img :data-id="item['pcId']" :src="item.image" alt="" srcset="" />
          <div :data-id="item['pcId']">
            {{ item["name"] }}
          </div>
        </div>
        <!-- <div class="menu_item" @click="switchCategory($event,index)" :class="categoryId===item['pcId']?'active':''" v-for="(item,index) in categoryList" :key="item['name']" :data-id="item['pcId']">{{item['name']}}</div> -->
      </u-animate>
      <u-animate
        class="product_content"
        name="fadeInDown"
        delay="0s"
        duration="1s"
        :iteration="1"
        :offset="0"
        animateClass="animated"
        :begin="false"
      >
        <!-- <div class="breadcrumb">
          <router-link to="/index">{{ $t("footer.web.index") }}</router-link>
          <span>&gt;</span>
          <router-link to="/product/0">{{ $t("menu.product") }}</router-link>
          <span v-show="categoryId !== 0">&gt;</span>
          <span class="active" v-show="categoryId !== 0">{{
            categoryName
          }}</span>
        </div> -->
        <div class="product_list" v-if="productList.length !== 0">
          <u-animate
            v-for="item in productList"
            :key="item.name + item.productId"
            class="product_item"
            name="fadeIn"
            delay="0.3s"
            duration="1s"
            :iteration="0"
            :offset="0"
            animateClass="animated"
            :begin="false"
          >
            <div class="nav">
              <div class="nav_item"></div>
              <div class="nav_item"></div>
              <div class="nav_item"></div>
            </div>
            <router-link
              :to="
                '/pd/' +
                  item.productId +
                  '/' +
                  encodeURI(item.name.replace('/', ''))
              "
              class="item_product_cn"
            >
              <img
                :src="item.image"
                class="item_product_img"
                :alt="item.keyword"
              />
            </router-link>
            <router-link
              :to="
                '/pd/' +
                  item.productId +
                  '/' +
                  encodeURI(item.name.replace('/', ''))
              "
              class="item_product_cn_name"
              tag="p"
            >
              <span>{{ item.name }}</span>
              <span> {{ item.number }}</span>
            </router-link>
            <!-- hover外层 -->
            <transition
              enter-active-class="animated fadeIn"
              leave-active-class="animated fadeOut"
            >
              <router-link
                :to="
                  '/pd/' +
                    item.productId +
                    '/' +
                    encodeURI(item.name.replace('/', ''))
                "
              >
                <div class="item_product_wrap">
                  <div class="item_product_transparent"></div>
                  <div class="item_product_bottom">
                    <div class="item_product_desc">{{ item.desc }}</div>
                    <div class="btn_product_detail">
                      {{ $t("index.product") }}
                    </div>
                  </div>
                </div></router-link
              >
            </transition>
          </u-animate>
          <infinite-loading
            style="width:100%;max-height: 800px;min-height: 300px;"
            direction="bottom"
            @infinite="infiniteHandler"
          >
            <div
              slot="no-more"
              style="color:#ccc;font-size:0.2rem;margin-top:25px;"
            >
              已经到底了~
            </div>
            <div
              slot="no-results"
              style="color:#ccc;font-size:0.2rem;margin-top:25px;"
            ></div>
          </infinite-loading>
        </div>
      </u-animate>
    </u-animate-container>

    <common-footer :locale="locale"></common-footer>
  </div>
</template>

<script>
import { UAnimateContainer, UAnimate } from "vue-wow";
import InfiniteLoading from "vue-infinite-loading";
import CommonHeader from "./components/Common/Header";
import CommonNav from "./components/Common/OtherNav";
import CommonFooter from "./components/Common/Footer";
import CommonBanner from "./components/Common/Banner";
import CommonTitle from "./components/Common/Title";
export default {
  name: "product",
  components: {
    UAnimateContainer,
    UAnimate,
    CommonHeader,
    CommonNav,
    CommonFooter,
    CommonBanner,
    CommonTitle,
    InfiniteLoading
  },
  data() {
    return {
      categoryList: [],
      categoryId: 0,
      categoryName: "",
      productList: [],
      page: 1,
      currentPage: 1,
      petPage: 12,
      total: 0,
      isAcitveIndex: 0,
      lastPage: 1,
      locale: "zh-cn"
    };
  },
  created() {
    let _router = this.$route;
    let _id = parseInt(_router.params.id);
    console.log(_router);
    this.categoryId = parseInt(_id);
    this.locale = window.localStorage.getItem("lang")
      ? window.localStorage.getItem("lang")
      : "zh-cn";
    // this.$route.meta.title = '动态修改的首页'
    this.getCategory(this.categoryId, this.locale);
    this.getProduct(this.categoryId, this.page, this.locale);
  },
  watch: {
    isAcitveIndex: {
      handler(_newval, _oldval) {
        this.isAcitveIndex = _newval;
        // console.log(this.isAcitveIndex)
      },
      deep: true,
      immediate: true
    },
    locale(a, b) {
      this.getCategory(this.categoryId, a);
      this.getProduct(this.categoryId, this.page, a);
    }
  },
  methods: {
    getLocale(e) {
      this.locale = e;
    },
    // 获取产品分类
    getCategory(id, lang) {
      let lang2 = lang ? lang : "zh-cn";
      this.$axios
        .post(
          "/api/product/categoryList",
          {},
          {
            headers: {
              token: "application",
              "Accept-Language": lang2
            }
          }
        )
        .then(res => {
          console.log("获取产品分类", res);
          if (res.data.errorCode === 0) {
            this.categoryList = res.data.data.categoryList;
            if (this.categoryId !== 0) {
              var i = 0;
              for (i in res.data.data.categoryList) {
                console.log(res.data.data.categoryList[i]["pcId"], id);
                if (res.data.data.categoryList[i]["pcId"] === id) {
                  console.log(res.data.data.categoryList[i]["name"]);
                  this.categoryName = res.data.data.categoryList[i]["name"];
                  this.isAcitveIndex = i;
                  // console.log(this.isAcitveIndex, i)
                  break;
                }
              }
            }
          } else {
            this.$alert(res.data.errorMsg);
          }
        });
    },
    // 点击切换产品分类，分页归零
    switchCategory(e, index) {
      debugger;
      console.log(e, index, "111111");
      var _id = e.target.dataset.id;
      this.isAcitveIndex = index;
      this.categoryName = e.target.innerText;
      this.categoryId = _id;
      this.getProduct(this.categoryId, 1, this.locale);
      // console.log(this.categoryId)
      // console.log(e.target.dataset.id)
    },
    infiniteHandler($state) {
      let lang2 = this.locale ? this.locale : "zh-cn";
      this.$axios
        .post(
          "/api/product/list",
          {
            pcId: this.categoryId,
            page: this.page
          },
          {
            headers: {
              token: "application",
              "Accept-Language": lang2
            }
          }
        )
        .then(res => {
          console.log("产品列表：第" + this.page + "页");
          console.log(res);
          if (res.data.errorCode === 0) {
            if (
              res.data.data.productList.currentPage !==
              res.data.data.productList.lastPage
            ) {
              this.productList.push(...res.data.data.productList.data);

              this.page += 1;
              $state.loaded();
            } else {
              $state.complete();
            }
            this.currentPage = res.data.data.productList.currentPage;
            this.lastPage = res.data.data.productList.lastPage;
            this.perPage = res.data.data.productList.perPage;
            this.total = res.data.data.productList.total;
          }
        });
    },
    // 获取产品列表
    getProduct(id, page, lang) {
      let lang2 = lang ? lang : "zh-cn";
      this.$axios
        .post(
          "/api/product/list",
          {
            pcId: id,
            page: page
          },
          {
            headers: {
              token: "application",
              "Accept-Language": lang2
            }
          }
        )
        .then(res => {
          console.log("产品列表：第" + this.page + "页");
          console.log(res);
          if (res.data.errorCode === 0) {
            this.productList = res.data.data.productList.data;
            this.currentPage = res.data.data.productList.currentPage;
            this.lastPage = res.data.data.productList.lastPage;
            this.total = res.data.data.productList.total;
          }
        });
    }
  }
};
</script>

<style scoped lang="scss">
.product_list {
  display: none;
}
.product_area {
  width: 1600px;
  margin: 60px auto;
  min-height: 500px;
  height: auto;
  justify-content: flex-start;
  overflow: hidden;
  .product_cate {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 0.5rem;
    .menu_title {
      height: 40px;
      font-size: 0.2rem;
      color: #333;
      span {
        font-size: 0.13rem;
        margin-left: 20px;
        position: relative;
        top: 1px;
      }
    }
    .menu_item {
      color: #333;
      font-size: 0.16em;
      transition: all 0.35s;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 30px;
      margin-bottom: 15px;
      img {
        margin-bottom: 0.2rem;
        width: 80px;
        height: 80px;
      }
      &:hover,
      &.active {
        color: #fb8001;
      }
      &:last-child {
        border-bottom: 0;
      }
    }
  }
  .product_content {
    width: 100%;
    box-sizing: border-box;
    .breadcrumb {
      height: 40px;
      font-size: 0.16rem;
      color: #ccc;
      text-align: right;
      span {
        margin: 0 3px;
        &.active {
          color: #fb8001;
        }
      }
      a {
        outline: none;
        text-decoration: none;
        color: #ccc;
        transition: all 0.35s;
        &:hover {
          color: #fb8001;
        }
      }
    }
    .product_list {
      max-width: 1400px;
      margin: 0 auto;
      display: flex;
      display: -ms-flexbox;
      flex-wrap: wrap;
      justify-content: flex-start;
      min-height: 500px;
      max-height: 800px;
      overflow-y: auto;
      padding-top: 0.1rem;
      .product_item {
        width: 360px;
        float: left;
        height: 420px;
        border-radius: 4px;
        background: #fff;
        margin-bottom: 15px;
        margin-right: 0.5rem;
        // background: url("../assets/images/product_bg.jpg") no-repeat center
        //   center;
        background-size: 100% 100%;
        position: relative;
        font-size: 0.2rem;
        visibility: visible !important;
        &:nth-of-type(3n) {
          margin-right: 0;
        }
        &:nth-of-type(3n + 1) {
          margin-left: 0.1rem;
        }
        .nav {
          width: 100%;
          height: 5px;
          margin-top: 10px;
          position: absolute;
          bottom: 10px;
          .nav_item {
            height: 5px;
            width: 32%;
            float: left;
            position: relative;
            &::after,
            &::before {
              position: absolute;
              content: "";
              width: 0;
              height: 0;
              z-index: 2;
            }
            &:nth-of-type(1) {
              background: #54565a;
              &::after {
                right: 0;
                top: 0;
                border-left: 5px solid transparent;
                border-bottom: 5px solid #fff;
              }
            }
            &:nth-of-type(2) {
              background: #e04307;
              width: 34%;
              &::before {
                left: 0;
                top: 0;
                border-right: 5px solid transparent;
                border-top: 5px solid #fff;
              }
              &::after {
                right: 0;
                top: 0;
                border-left: 5px solid transparent;
                border-bottom: 5px solid #fff;
              }
            }
            &:nth-of-type(3) {
              background: #fd8204;
              &::before {
                left: 0;
                top: 0;
                border-right: 5px solid transparent;
                border-top: 5px solid #fff;
              }
            }
          }
        }
        .item_product_img {
          width: 100%;
          height: 100%;
          float: right;
          margin-top: 10px;
          display: block;
          transition: all 0.35s;
        }
        .item_product_cn {
          box-sizing: border-box;
          font-size: 0.14rem;
          position: absolute;
          left: 20px;
          &_name {
            position: absolute;
            font-size: 0.14rem;
            bottom: -10px;
            width: 100%;
            display: flex;
            padding: 0 10px;
            box-sizing: border-box;
            justify-content: space-between;
          }
        }
        .item_product_en {
          box-sizing: border-box;
          position: absolute;
          color: #666;
          font-size: 0.12rem;
          left: 20px;
          top: 0.62rem;
        }
        .item_product_wrap {
          display: none;
          z-index: 99;
          position: absolute;
          left: -10px;
          top: -10px;
          width: 360px;
          min-height: 300px;
          border: 10px solid #fd8204;
          color: #fff;
          font-size: 0.14rem;
          transition: all 0.35s;
          .item_product_transparent {
            width: 100%;
            height: 390px;
            background: none;
          }
          .item_product_bottom {
            background: #fd8204;
            padding-bottom: 30px;
            .item_product_desc {
              box-sizing: border-box;
              padding: 15px 10px;
              line-height: 1.8;
            }
            .btn_product_detail {
              width: 130px;
              border: 2px solid #fff;
              height: 40px;
              font-size: 0.14rem;
              border-radius: 30px;
              text-align: center;
              background: #fd8204;
              line-height: 40px;
              margin: 0 auto;
              color: #fff;
              display: block;
              text-decoration: none;
            }
          }
        }
        &:hover {
          .item_product_wrap {
            display: block;
          }
        }
        &.product_null {
          .item_product_img {
            width: auto;
            height: 240px;
            position: relative;
            margin: 15px auto 0;
            float: none;
          }
        }
      }
    }
    // 隐藏滚动条
    .product_list::-webkit-scrollbar {
      width: 0 !important;
    }

    .product_list {
      -ms-overflow-style: none;
    }

    .product_list {
      overflow: -moz-scrollbars-none;
    }
  }
}
.product_area_bg,
.mobile_product_nav {
  display: none;
}
@media screen and (max-width: 750px) {
  .product_area_bg {
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    object-fit: cover;
    z-index: 0;
  }
  .product_wrap {
    background: #e6e6e6;
  }
  .product_area {
    width: 100%;
    margin: 0px auto 0px;
    box-sizing: border-box;
    padding: 0 15px 30px;
    position: relative;
    z-index: 9;
    .product_cate {
      display: none;
    }
    .product_content {
      padding-left: 0;
      .breadcrumb {
        display: none;
      }
      .product_list {
        min-height: 300px;
        max-height: 500px;
        .product_item {
          width: 50%;
          height: auto;
          margin-right: 0;
          margin-bottom: 0;
          border-right: 2px solid #eee;
          border-bottom: 2px solid #eee;
          box-sizing: border-box;
          padding-bottom: 15px;
          background: none;
          background: #fff;
          &:hover {
            .item_product_wrap {
              display: none;
            }
          }
          &:nth-of-type(3n) {
            &:nth-of-type(2n) {
              border-right: 0;
            }
          }
          &:nth-of-type(3n + 1) {
            margin-left: 0;
          }
          .nav {
            width: 60%;
            height: 0.2rem;
            .nav_item {
              height: 0.22rem;
            }
          }
          .item_product_img {
            width: 80%;
            height: auto;
            float: none;
            margin: 0.5rem auto 0.5rem;
          }
          .item_product_cn,
          .item_product_en {
            position: relative;
            top: auto;
            left: auto;
            box-sizing: border-box;
            padding: 0 10%;
            font-size: 0.7rem;
            color: #666;
            &.item_product_en {
              font-size: 0.5rem;
              transform: scale(0.8);
              transform-origin: 0 0;
              line-height: 1.5;
              margin-top: 0.15rem;
              float: left;
            }
          }
          &.product_null {
            .item_product_img {
              width: 80%;
              height: auto;
            }
          }
        }
      }
    }
  }
  .mobile_product_nav {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    position: relative;
    z-index: 999;
    margin-bottom: 15px;
    .mobile_product_nav_item {
      border: 1px solid #333;
      font-size: 0.7rem;
      padding: 6px 12px;
      margin-right: 10px;
      margin-bottom: 15px;
      &.active {
        background: #fb8001;
        color: #333;
        font-weight: bold;
        border-color: #fb8001;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Product.vue